<template>
  <v-app>
    <v-container class="mt-16">
      <v-row justify="center">
        <v-col cols="12" md="6">
          <my-setting
            v-bind:isRegistering="true"
            v-bind:userId="userId"
          ></my-setting>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import MySetting from "@/views/MySetting";
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");
export default {
  name: "Register",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,

    address: null,
    city: null,
    zipcode: null,
    bio: null,
    occupation: null,
  }),
  components: {
    MySetting,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    console.log(this.currentUser.uid);
    // if (!this.isRegistering) {
    //   fb.usersCollection
    //     .doc(this.currentUser.uid)
    //     .get()
    //     .then((doc) => {
    //       if (doc.exists) {
    //         let userData = doc.data()
    //         if (this.currentUser.uid) {
    //           this.firstName = userData.firstName;
    //           if (userData.email != undefined)
    //             this.email = userData.email;
    //         }
    //         this.lastName = userData.lastName
    //         this.address = userData.address
    //         this.city = userData.city
    //         this.zipcode = userData.zipcode
    //         this.bio = userData.bio
    //         this.occupation = userData.occupation
    //       }
    //     });
    // }
  },
  methods: {
    save() {
      fb.usersCollection
        .doc(this.currentUser.uid)
        .update({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          address: this.address,
          city: this.city,
          zipcode: this.zipcode,
          bio: this.bio,
          occupation: this.occupation,
        })
        .then(() => {
          if (this.isRegistering) this.$router.push("/");
        })
        .catch((err) => {});
    },
  },
  props: {
    isRegistering: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: false,
    },
  },
};
</script>
